const SET_SESSION = 'session/SET_SESSION';
const RELOGIN = 'session/RELOGIN';
const NEED_LOGIN = 'session/NEED_LOGIN';
const LOGOUT = 'session/LOGOUT';
const SET_SAVE_STATE = 'session/SET_SAVE_STATE';
const SET_AUTO_SAVE = 'session/SET_AUTO_SAVE';

// {
//     "session": {
//         "user": {
//             "userID": "zhouwei",
//             "username": "周老师",
//             "userInfo": {
//                 "UserId": "zhouwei",
//                 "Nick": "周老师",
//                 "Email": "769479627@qq.com",
//                 "Submit": 486,
//                 "Solved": 146,
//                 "Defunct": "N",
//                 "Accesstime": "2023-10-05T13:29:00+08:00",
//                 "Volume": 10,
//                 "Avatar": "https://oj-1256154465.cos.ap-shanghai.myqcloud.com/wangpan/15vDgGWR_cfeb97daf245c01e824b6b909a22156.jpg",
//                 "Language": 1,
//                 "Password": "",
//                 "Description": "",
//                 "School": "pachong",
//                 "UserRight": "AT",
//                 "Ip": "",
//                 "RegTime": "0001-01-01T00:00:00Z"
//             }
//         }
//     },
//     "reLogin": false,
//     "needLogin": false,
//     "logout": false
// }
// 登录状态
const initialState = {

    session: {
        user: {
            username: localStorage.getItem("nick"),//用户名 用Nick
        },
    },
    saveState: -1,
    autoSave: true,
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;

    switch (action.type) {
        case SET_SESSION:
            return Object.assign({}, state, action.session);
        case RELOGIN:
            localStorage.clear();
            return Object.assign({}, state, { reLogin: true, session: undefined });
        case NEED_LOGIN:
            return Object.assign({}, state, { needLogin: true });
        case LOGOUT:
            localStorage.clear();
            return Object.assign({}, state, { logout: true, session: undefined });
        case SET_SAVE_STATE:
            return Object.assign({}, state, { saveState: action.saveState });
        case SET_AUTO_SAVE:
            return Object.assign({}, state, { autoSave: action.autoSave });
    }
    return state;
};
const setSession = session => ({ type: SET_SESSION, session: session });
const reLogin = () => ({ type: RELOGIN });
const needLogin = () => ({ type: NEED_LOGIN });
const logout = () => ({ type: LOGOUT });
const setSaveState = saveState => ({ type: SET_SAVE_STATE, saveState: saveState });
const setAutoSave = autoSave => ({ type: SET_AUTO_SAVE, autoSave: autoSave });

export {
    reducer as default,
    initialState as sessionInitialState,
    setSession,
    reLogin,
    needLogin,
    logout,
    setSaveState,
    setAutoSave
};
